import { comments } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-2">
            观众评价
          </h2>
          <p className="text-sm text-foreground-600">
            来看看影迷朋友们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {comments.map((cm, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-accent-200/50 transition-all duration-300"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <span className="font-heading text-sm md:text-base font-bold text-accent-600">
                    {cm.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <h4 className="font-medium text-sm md:text-base text-foreground-900">{cm.name}</h4>
                  <p className="text-xs text-foreground-500">{cm.date}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">
                {cm.content}
              </p>
              <div className="flex items-center gap-1 mt-3 text-accent-500">
                {[...Array(5)].map((_, j) => (
                  <i key={j} className="ri-star-fill text-xs"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}